import { Link } from "react-router-dom";
import { Instagram, MessageCircle, MapPin } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { waLink } from "@/lib/site";

const Footer = () => {
  const { settings, isEnabled } = useSite();

  const links = [
    { label: "Empresas", to: "/empresas", key: "all_businesses" },
    { label: "Notícias", to: "/#news", key: "news" },
    { label: "Eventos", to: "/#events", key: "events" },
    { label: "Empregos", to: "/#jobs", key: "jobs" },
    { label: "Imóveis", to: "/#rentals", key: "rentals" },
    { label: "Cupons", to: "/#coupons", key: "coupons" },
  ].filter((l) => !l.key || isEnabled(l.key));

  return (
    <footer id="footer" className="bg-foreground text-white mt-6 pb-24 md:pb-6" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-8">
          <div className="max-w-sm">
            <div className="flex items-center gap-2 mb-3">
              <div className="h-9 w-9 rounded-xl bg-primary flex items-center justify-center font-bold font-heading">
                DP
              </div>
              <span className="font-bold font-heading text-lg">{settings?.site_name || "Divulga Pocinhos Guia"}</span>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              {settings?.slogan || "Comércio, serviços, notícias e oportunidades em Pocinhos-PB."}
            </p>
            <div className="flex items-center gap-1 mt-3 text-sm text-white/60">
              <MapPin className="w-4 h-4" /> Pocinhos, Paraíba
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-3 font-heading">Navegação</h4>
            <ul className="space-y-2">
              {links.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-white/70 hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 font-heading">Fale conosco</h4>
            <div className="flex gap-3">
              {settings?.instagram && (
                <a href={settings.instagram} target="_blank" rel="noreferrer" className="p-2.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors" data-testid="footer-instagram">
                  <Instagram className="w-5 h-5" />
                </a>
              )}
              {settings?.whatsapp && (
                <a href={waLink(settings.whatsapp, "Olá! Vim pelo Divulga Pocinhos Guia.")} target="_blank" rel="noreferrer" className="p-2.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors" data-testid="footer-whatsapp">
                  <MessageCircle className="w-5 h-5" />
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 mt-8 pt-5 text-center text-xs text-white/50">
          © {new Date().getFullYear()} {settings?.site_name || "Divulga Pocinhos Guia"} — Todos os direitos reservados.
          <Link to="/admin" className="ml-2 underline hover:text-white/80" data-testid="footer-admin-link">Painel</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
